import React, { useContext, useState } from "react";
import { HashLoader } from "react-spinners";
import * as api from "../api/index";
import GlobalContext from '../context/GlobalContext';
import { useNavigate } from "react-router-dom";

const InitState = {
  firstName: "",
  lastName: "",
  email: "",
  userName: "",
  password: "",
  confirmPassword: "",
  profilePicture: "",
  profileColor: "",
};

const labelsClasses = [
  "indigo",
  "gray",
  "green",
  "blue",
  "purple",
  "red",
  "orange",
  "pink",
  "cyan",
];

function Register() {
  const [sForm, setsForm] = useState(InitState);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [message, setMessage] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useNavigate();

  const handleChange = (e) =>
    setsForm({
      ...sForm,
      [e.target.name]: e.target.value,
    });

  async function handleOnSubmit(e) {
    setLoading(true);
    e.preventDefault();

    try {
      const { data } = await api.Register(sForm);
      if (data.success) {
        setThemeColor("themeGreen");
        setMessage(data.message);
        localStorage.clear();
        history("/account/registrationSuccess");
      } else {
        setThemeColor("themeRed");
        setMessage(data.message);
      }
      setLoading(false);
    } catch (err) {
      alert(err);
    }

    setLoading(false);
  }

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertToBase64(file);
    setsForm({
      ...sForm,
      [e.target.name]: base64,
    });
  };

  const updatLabel = (e, lblClass) => {
    setSelectedLabel(lblClass);
    setsForm({
      ...sForm,
      [e.target.attributes[0].value]: lblClass,
    });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  return (
    <>
      {loading ? (
        <HashLoader size={150} color={"#2A25EC"} loading={loading}></HashLoader>
      ) : (
        <form className="registerContainer">
          <div className="registerContainerv2">
            <h1>Create your account</h1>
            {message && <h4 className={themeColor}>{message}</h4>}
            <div className="row">
              <div className="inputContainer">
                <label>FRIST NAME</label>
                <input
                  onChange={handleChange}
                  name="firstName"
                  placeholder="Enter your first name"
                  type="text"
                />
              </div>
              <div className="inputContainer">
                <label>LAST NAME</label>
                <input
                  name="lastName"
                  onChange={handleChange}
                  placeholder="Enter your last name"
                  type="text"
                />
              </div>
            </div>

            <div className="row">
              <div className="inputContainer">
                <label>EMAIL</label>
                <input
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter your email"
                  type="email"
                />
              </div>
              <div className="inputContainer">
                <label>USERNAME</label>
                <input
                  name="userName"
                  onChange={handleChange}
                  placeholder="Enter your username"
                  type="text"
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="row">
              <div className="inputContainer">
                <label>PASSWORD</label>
                <input
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter your password"
                  type="password"
                  autoComplete="new-password"
                />
              </div>
              <div className="inputContainer">
                <label>CONFIRM PASSWORD</label>
                <input
                  name="confirmPassword"
                  onChange={handleChange}
                  placeholder="Retype your password"
                  type="password"
                  autoComplete="new-password"
                />
              </div>
            </div>

            <div className="row">
              <label className="inputLabel">PROFILE COLOR</label>
              <div className="flex gap-x-2">
                {labelsClasses.map((lblClass, i) => (
                  <span
                    key={i}
                    name="profileColor"
                    onClick={(e) => updatLabel(e, lblClass)}
                    className={`bg-${lblClass}-500 w-6 h-6 rounded-full flex items-center justify-center cursor-pointer`}
                  >
                    {selectedLabel === lblClass && (
                      <span className="material-icons-outlined text-white text-sm">
                        check
                      </span>
                    )}
                  </span>
                ))}
              </div>
            </div>

            <div className="row">
              <div className="inputContainer">
                <label>PROFILE PICTURE</label>
                <input
                  name="profilePicture"
                  onChange={uploadImage}
                  placeholder="Please Select Profile Photo"
                  type="file"
                />
              </div>
            </div>

            <div className="footerContainer">
              <div>
                <strong>Already Signed Up?</strong>{" "}
                <a href="/account/login">Login</a>
              </div>
              {/* <div>
            <a href="/account/forgotpassword">Forgot Password?</a>
          </div> */}
            </div>

            <button onClick={handleOnSubmit} className="loginBTN">
              REGISTER
            </button>
          </div>
        </form>
      )}
    </>
  );
}

export default Register;
